import { toDate } from '@df/util/fn/to-date';

export function inDateRange(
    dateRangeFrom?: string | number | Date,
    dateRangeTo?: string | number | Date,
    date?: string | number | Date
): boolean {
    const comparedDate = date ? toDate(date) : new Date();

    if (!comparedDate) {
        return false;
    }
    const from = toDate(dateRangeFrom);
    if (from && from > comparedDate) {
        return false;
    }

    const to = toDate(dateRangeTo);
    if (to && to < comparedDate) {
        return false;
    }

    return true;
}
